import { RouteRecordRaw } from 'vue-router'

import { LayoutDefaultSuspense } from '@/pages/suspense'

import { UserRoles } from '@/shared/types/router'

export const useDefaultLayout = (routeRecord: RouteRecordRaw): RouteRecordRaw => {
  if (!routeRecord.meta) {
    routeRecord.meta = {}
  }
  routeRecord.meta.layout = LayoutDefaultSuspense
  routeRecord.meta.roles = [UserRoles.ANONYMOUS, UserRoles.GUEST, UserRoles.SUPPORT]
  return routeRecord
}
